import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ThinAddIcon, ThinEditIcon, ThinnerPeopleIcon, ThinPrintIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";
import {AddEditClassModal} from "./add-edit-class";
import {AdminsAssignStudentsToClass} from "./assign-student";
import '../../../static/css/pages/class/class.css';
import {AdminClassesPrintStudentsModal} from "./print-modal";
import {useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";

export interface classInterface {
    id: number,
    title: string,
    grade: number,
    students: number,
}

export const AdminClassesScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as classInterface[]);
    const [can,setCan] = useState({
       addEdit:false,
       assign:false,
    });
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/class/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: classInterface[] | null,
                canAdd:boolean,
                canAssign:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setCan({
                   addEdit: d.canAdd,
                   assign: d.canAssign,
                });
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
                ShowConnectionFailed('fa');
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "کلاس‌ها | نهال";
        fetchList();
    }, []);
    const [addEdit, setAddEdit] = useState({
        show: false,
        edit: false,
        id: 0,
    });
    const [assignModal, setAssignModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    const [printModal, setPrintModal] = useState({
        show: false,
        id: 0,
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'کلاس‌ها', url: '/admins/classes'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration="1000">
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>لیست کلاس‌ها</b>
                                {
                                    can.addEdit ?
                                        <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                            <button onClick={() => setAddEdit({
                                                show: true,
                                                edit: false,
                                                id: 0,
                                            })}>
                                                <ThinAddIcon/>
                                                <span>افزدون کلاس</span>
                                            </button>
                                        </div>
                                        : null
                                }
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>نام کلاس</th>
                                    <th>پایه</th>
                                    <th>تعداد دانش‌آموز</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"Ksi322riJaS9" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>{s.title}</td>
                                            <td>{GradeToString(s.grade)}</td>
                                            <td>{CurrencyFormat(s.students)}</td>
                                            <td>
                                                <div
                                                    className="d-inline-flex justify-content-center align-items-center"
                                                    style={{gap: 10}}>
                                                    <button className="open-tooltip" onClick={() => setPrintModal({
                                                        show: true,
                                                        id: s.id,
                                                    })}>
                                                        <ThinPrintIcon/>
                                                        <i>پرینت</i>
                                                    </button>
                                                    {
                                                        can.addEdit ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setAddEdit({
                                                                        show: true,
                                                                        edit: true,
                                                                        id: s.id,
                                                                    })}>
                                                                <ThinEditIcon/>
                                                                <i>ویرایش</i>
                                                            </button> : null
                                                    }
                                                    {
                                                        can.assign ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setAssignModal({
                                                                        show: true,
                                                                        id: s.id,
                                                                        title: s.title,
                                                                    })}>
                                                                <ThinnerPeopleIcon/>
                                                                <i>اختصاص دانش‌آموزان</i>
                                                            </button> : null
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AddEditClassModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                onDone={() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    ShowProgressLoading();
                    fetchList();
                }}
                isEdit={addEdit.edit}
                classId={addEdit.id.toString()}
            />
            <AdminsAssignStudentsToClass
                active={assignModal.show}
                closeHandler={() => {
                    setAssignModal(v => {
                        let x = {...v};
                        x.show = false;
                        return x;
                    });
                    ShowProgressLoading();
                    fetchList();
                }}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                classId={assignModal.id}
                classTitle={assignModal.title}
            />
            <AdminClassesPrintStudentsModal
                active={printModal.show}
                closeHandler={()=>setPrintModal(v=>{
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                classId={printModal.id}
            />
        </>
    );
};